import type { ReactNode } from "react";

import { ShieldWarningIcon } from "@phosphor-icons/react";
import { Button, Tooltip } from "@radix-ui/themes";

import { cn } from "~/v2/utils/cn";
import type { RiskControlsSummary } from "./riskControls.model";

export interface RiskControlsButtonPresentationProps {
  collapsed?: boolean;
  summary: RiskControlsSummary;
  onOpen: () => void;
  dialog: ReactNode;
}

export const RiskControlsButtonPresentation = ({
  collapsed = false,
  summary,
  onOpen,
  dialog,
}: RiskControlsButtonPresentationProps) => {
  const trigger = (
    <Button
      type="button"
      size={collapsed ? "1" : "2"}
      variant="soft"
      color={summary.color}
      // The visible text is abbreviated when collapsed, so the full state has
      // to reach assistive tech some other way.
      aria-label={collapsed ? summary.label : undefined}
      onClick={onOpen}
      // Matches the rail's row geometry so the shield lines up with the icons
      // above it instead of overflowing the rail.
      className={cn(
        collapsed && "h-8 w-full justify-start rounded-[6px] px-[10px]",
      )}
    >
      <ShieldWarningIcon size={16} aria-hidden />
      {collapsed ? summary.shortLabel : summary.label}
    </Button>
  );

  return (
    <>
      {collapsed ? (
        <Tooltip content={summary.label}>{trigger}</Tooltip>
      ) : (
        trigger
      )}
      {dialog}
    </>
  );
};
